export default {"src":"/_next/static/media/circleArrowDown_40.028b3713.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};